import { createUniqKey } from 'Utils';

export interface IEventTicket {
  id: string,
  name: string,
  description: string,
  createdAt: Date | null,
  startAt: Date | null,
  endAt: Date | null,
  date: Date|null,
  startTime: string,
  endTime: string,
  amount: number,
  currentlyPurchased: number|null,
  currentlyAvailable: number|null,
  shipping: string,
  tax: number,
  price: number,
  includeFee: boolean,
  externalTicketing: boolean,
  externalTicketingUrl: string | null,
  hasReduction: boolean,
  notSellable: boolean,
  reductionDescription: string | null,
  reductionAttentionDescription: string | null,
  wholeDay: boolean,
  eventId: string | null,
  condition: string | null,
  allowedDays: number[],
}

export class EventTicket {
  public _key: string;
  public id: string;
  public createdAt: Date | null;
  public name: string | null;
  public description: string | null;
  public startAt: Date | null;
  public endAt: Date | null;
  public date: Date | null;
  public startTime: string | null;
  public endTime: string | null;
  public amount: number;
  public currentlyPurchased: number|null;
  public currentlyAvailable: number|null;
  public shipping: string;
  public tax: number;
  public price: number;
  public includeFee: boolean;
  public wholeDay: boolean;
  public externalTicketing: boolean;
  public externalTicketingUrl: string | null;
  public hasReduction: boolean;
  public notSellable: boolean;
  public reductionDescription: string | null;
  public reductionAttentionDescription: string | null;
  public eventId: string | null;
  public condition: string | null;
  public allowedDays: number[];

  constructor(data: IEventTicket) {
    this._key = createUniqKey();

    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.amount = data.amount;
    this.currentlyPurchased = data.currentlyPurchased || null;
    this.currentlyAvailable = data.currentlyAvailable || null;
    this.tax = data.tax;
    this.price = data.price;
    this.includeFee = data.includeFee;
    this.externalTicketing = data.externalTicketing;
    this.wholeDay = data.wholeDay ?? true;
    this.shipping = data.shipping ?? 'noShipping';
    this.externalTicketingUrl = data.externalTicketingUrl;
    this.condition = data.condition;
    this.hasReduction = data.hasReduction;
    this.notSellable = data.notSellable;
    this.reductionDescription = data.reductionDescription;
    this.reductionAttentionDescription = data.reductionAttentionDescription;
    this.eventId = data.eventId;
    this.date = data.date ? new Date(data.date as unknown as number * 1000) : null;
    this.startTime = data.startTime;
    this.endTime = data.endTime;
    this.allowedDays = data.allowedDays || [];
    this.createdAt = data.createdAt ? new Date(data.createdAt as unknown as number * 1000) : null;
    this.startAt = data.startAt ? new Date(data.startAt as unknown as number * 1000) : null;
    this.endAt = data.endAt ? new Date(data.endAt as unknown as number * 1000) : null;
  }
}

export const createNewEventTicket = (data: Partial<IEventTicket> = {}): EventTicket => new EventTicket({
  id: data.id || 'new',
  name: data.name || '',
  description: data.description || '',
  amount: data.amount || 0,
  currentlyPurchased: data.currentlyPurchased || null,
  currentlyAvailable: data.currentlyAvailable || null,
  tax: data.tax || 0,
  price: data.price || 0,
  includeFee: data.includeFee ?? false,
  wholeDay: data.wholeDay ?? true,
  shipping: data.shipping ?? 'noShipping',
  externalTicketing: data.externalTicketing ?? false,
  externalTicketingUrl: data.externalTicketingUrl ?? '',
  hasReduction: data.hasReduction ?? false,
  notSellable: data.notSellable ?? false,
  reductionDescription: data.reductionDescription ?? '',
  reductionAttentionDescription: data.reductionAttentionDescription ?? '',
  condition: data.condition ?? '',
  allowedDays: data.allowedDays ? data.allowedDays : [],
  createdAt: data.createdAt || null,
  eventId: data.eventId || null,
  startAt: data.startAt || null,
  endAt: data.endAt || null,
  date: data.date || null,
  startTime: data.startTime || '',
  endTime: data.endTime || '',
});
